// eslint-disable-next-line import/prefer-default-export
export const VERSION = '1.0.238';



// WEBPACK FOOTER //
// ./src/utils/Constant.js